import type { RefObject } from 'react';
import { fadeTo } from 'util/animation/fade/fade';

interface StatisticsRefs {
  elementRef: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: StatisticsRefs,
): void {
  timeline.fromTo(elementRef.current, {}, {});
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: StatisticsRefs,
): void {
  timeline.add(fadeTo(elementRef.current as HTMLElement));
}

export const animateNumbers = (
  timeline: gsap.core.Timeline,
  { numberRef }: { numberRef: RefObject<HTMLElement | null> },
): void => {
  if (!numberRef?.current) return;
  if (numberRef.current.textContent === '0') return;

  const decimalSplit = numberRef.current.textContent?.split('.');
  const sizeWholePart = decimalSplit?.[0]?.length || 0;
  const sizeDecimalPart = decimalSplit?.[1]?.length || 0;

  const increment = 10 ** (-1 * sizeDecimalPart);

  timeline.from(numberRef.current, {
    textContent: 0,
    duration: 1,
    ease: 'power1.out',
    snap: { textContent: increment },
    modifiers: { textContent: (x) => x.toFixed(sizeDecimalPart).padStart(sizeWholePart, '0') },
    stagger: {
      each: increment,
    },
  });
};
